<script lang="ts">
  import { mediaBytes } from '$lib/media/fetch';
  import { defang } from '$lib/protocol/link-guard';
  import type { ImageElement } from '$lib/protocol/types';

  import type { ElementContext } from './context';

  let { element, ctx }: { element: ImageElement; ctx: ElementContext } = $props();

  let url = $state<string | undefined>(undefined);
  let failed = $state(false);
  let expanded = $state(false);

  $effect(() => {
    let revoked = false;
    void mediaBytes(ctx.accountId, element.mediaId).then((media) => {
      if (media === undefined) {
        failed = true;
        return;
      }
      const objectUrl = URL.createObjectURL(
        new Blob([media.bytes as BlobPart], { type: media.contentType }),
      );
      if (revoked) {
        URL.revokeObjectURL(objectUrl);
      } else {
        url = objectUrl;
      }
    });
    return () => {
      revoked = true;
      if (url !== undefined) {
        URL.revokeObjectURL(url);
      }
    };
  });

  // Reserve the layout box from width/height so the conversation does not jump
  // when bytes arrive.
  const ratio = $derived(
    element.width !== undefined && element.height !== undefined && element.height > 0
      ? element.width / element.height
      : 4 / 3,
  );
</script>

<figure class="image">
  {#if url !== undefined}
    <button class="frame" style="aspect-ratio: {ratio}" onclick={() => (expanded = true)}>
      <img src={url} alt={element.caption ?? ''} />
    </button>
  {:else}
    <div class="frame placeholder" style="aspect-ratio: {ratio}">{failed ? '⚠' : '…'}</div>
  {/if}
  {#if element.caption !== undefined}
    <figcaption>{defang(element.caption)}</figcaption>
  {/if}
</figure>

{#if expanded && url !== undefined}
  <button class="lightbox" onclick={() => (expanded = false)} aria-label="close">
    <img src={url} alt={element.caption ?? ''} />
  </button>
{/if}

<style>
  .image {
    margin: 0;
    max-width: 280px;
  }
  .frame {
    display: block;
    width: 100%;
    border: 0;
    padding: 0;
    background: var(--surface-2);
    border-radius: 10px;
    overflow: hidden;
    cursor: zoom-in;
  }
  .frame img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ink-soft);
    font-size: 20px;
  }
  figcaption {
    font-size: 13px;
    color: var(--ink-soft);
    margin-top: 4px;
  }
  .lightbox {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 85%);
    border: 0;
    padding: 16px;
    z-index: 40;
    cursor: zoom-out;
  }
  .lightbox img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
